import React from 'react';


import art1 from './images/art1.png';
import art2 from './images/art2.png';
import art3 from './images/art3.png';
import art4 from './images/art4.png';
import art5 from './images/art5.png';
import art7 from './images/art7.png';
import art8 from './images/art8.png';
import art9 from './images/art9.png';
import art10 from './images/art10.png';
import art11 from './images/art11.png';
import art12 from './images/art12.png';


import ProjectsGallery from "./ProjectsGallery";


const images = [
  art1,
  art2,
  art3,
  art4,
  art5,
  art7,
  art8,
  art9,
  art10,
  art11,
  art12

];


export default function Home() {
  return <ProjectsGallery images={images} />;
}